var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isDescription)?_c('p',{staticClass:"text-sm text-slate-500",domProps:{"innerHTML":_vm._s(_vm.description)}}):_vm._e()}
var staticRenderFns = []
export { render, staticRenderFns }